/**************************************************
 * Nombre:       Seccion_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     12 Hr
 **************************************************/
import {Button, Grid, useMediaQuery} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_dialogos/Hooks/useDialogo";
import TituloNotificaciones from "../../Modulo_dashboard/ComponentesSecundarios/TituloNotificaciones";
import TablaBasica from "../../Modulo_tablas/Componentes/TablaBasica";
import {theme} from "../../Tema";
import {ESTADOPRODUCTOS} from "../../Constantes";
import {contarPropiedad} from "../../Servicios/BD/Contadores/contarPropiedad";
import {Interests, Inventory2Outlined, ManageSearch, TaskAlt} from "@mui/icons-material";
import {usuarioContext} from "../../App";
import Dialogo_Producto from "../Dialogos/Dialogo_Producto";
import {where} from "firebase/firestore";
import {useObtenerColleccionTablaWhere} from "../../Servicios/BD/useObtenerColleccionTablaWhere";
import Dialogo_Producto_Variante from "../Dialogos/Dialogo_Producto_Variante";
import Dialogo_Producto_Enviar from "../Dialogos/Dialogo_Producto_Enviar";

const Seccion_Catalogo = () => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const cData = useContext(usuarioContext)
    const [numProductos, setNumProductos] = useState(0)
    const [recargar, setRecargar] = useState(false)
    const [wheres, setWheres] = useState([where('idTienda', '==', 'none')])
    const {props, cargarNuevamente} = useObtenerColleccionTablaWhere({
        coleccion: 'productos',
        filtroInicial: 'fecha',
        dirInicial: 'desc',
        wheres: wheres
    })
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Producto,
        realizado: () => setRecargar(!recargar)
    })
    const {Dialogo: DialogoVariantes, abrir: abrirVariantes} = useDialogo({
        Componente: Dialogo_Producto_Variante,
        realizado: () => setRecargar(!recargar)
    })
    const {Dialogo: DialogoEnviar, abrir: abrirenviar} = useDialogo({
        Componente: Dialogo_Producto_Enviar,
        realizado: () => setRecargar(!recargar)
    })

    const manejardorClicks = (row, id) => {

        switch (id) {
            case 'editar' :
                abrir(row)
                break
            case 'variantes' :
                abrirVariantes(row)
                break
            case 'enviar' :
                abrirenviar(row)
                break
        }

    }

    const botones = [
        <Button
            color={'primary'}
            onClick={() => {

                if (cData.usuario.idTienda) {
                    abrir()
                } else {
                    alert('Primero debes crear tu tienda')
                }

            }}
            startIcon={<Inventory2Outlined/>}
            variant={'contained'}>
            {sCell ? 'Nuevo' : 'Nuevo Producto'}
        </Button>
    ]


    useEffect(() => {


        if (cData && cData.usuario && cData.usuario.idTienda) {
            let idTienda = cData.usuario.idTienda
            contarPropiedad({
                coleccion: 'productos',
                propiedad: 'idTienda',
                valor: idTienda
            }).then((dox) => {
                if (dox.res) {
                    setNumProductos(dox.data)
                }
            })

            setWheres([where('idTienda', '==', idTienda)])

        }


        cargarNuevamente()

    }, [recargar, cData]);
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
        >

            <Dialogo/>


            <DialogoVariantes/>

            <DialogoEnviar/>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start'}}>
                <TituloNotificaciones titulo={'Catalogo'} textoComplementario={'en catalogo'}
                                      textoResaltado={`${numProductos} Productos`} botones={botones}/>
            </Grid>


            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start', marginTop: 5}}>
                <TablaBasica
                    filtros={filtros}
                    datosCabecera={sCell ? datosCabeceraCell : datosCabecera}
                    {...props}
                    click={manejardorClicks}
                    botonesTabla={botonesTabla}
                />
            </Grid>


        </Grid>
    )

}
export default Seccion_Catalogo

const filtros = [
    {
        nombre: 'Nombre',
        propiedad: 'nombre',

    },
    {
        nombre: 'Categoria',
        propiedad: 'categoria',

    },
    {
        nombre: 'Mas Reciente',
        propiedad: 'fecha',
        direccion: 'desc'

    }
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',

    },
    {
        nombre: 'Categoria',
        direccion: 'left',
        propiedad: 'categoria',

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',

    },
    {
        nombre: 'N. Variantes',
        direccion: 'right',
        propiedad: 'variantes',
        tipo: 'contararray'

    }

]


const datosCabeceraCell = [
    {
        nombre: 'Fecha',
        direccion: 'left',
        propiedad: 'fecha',
        tipo: 'fecha'

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',

    }
]

const botonesTabla = [
    {
        nombre: 'Editar',
        icono: ManageSearch,
        id: 'editar'
    },
    {
        nombre: 'Variantes',
        icono: Interests,
        id: 'variantes'
    },
    {
        nombre: 'Enviar',
        icono: TaskAlt,
        id: 'enviar'
    },

]



